import { useQuery } from '@tanstack/react-query'
import { fetchApi } from '@/common/lib/fetchApi'

export interface Notification {
  id: string
  type: 'pay_period_closing' | 'timesheet_due' | 'timesheet_overdue'
  title: string
  message: string
  created_at: string
  read: boolean
  action_url: string | null
}

export function useNotifications() {
  const query = useQuery({
    queryKey: ['notifications'],
    queryFn: () => fetchApi<Notification[]>('/api/notifications'),
  })

  const unreadCount = query.data?.filter((n) => !n.read).length ?? 0

  return { ...query, unreadCount }
}
